import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

if (!supabaseUrl || !supabaseAnonKey) {
  console.error(
    'Missing Supabase environment variables. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY.'
  );
}

// Stable per-browser "installation" ID, sent on every request as x-device-id so
// the route-audit trigger (migration 015) can record which device made a change.
// Not a hardware ID — browsers don't expose one. It persists in localStorage and
// resets if the user clears site data or switches browser/profile.
const getDeviceId = () => {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return 'no-storage';
    let id = window.localStorage.getItem('bvm_device_id');
    if (!id) {
      id = window.crypto?.randomUUID
        ? window.crypto.randomUUID()
        : `dev-${Date.now()}-${Math.random().toString(16).slice(2)}`;
      window.localStorage.setItem('bvm_device_id', id);
    }
    return id;
  } catch {
    return 'unavailable';
  }
};

export const supabase = supabaseUrl && supabaseAnonKey
  ? createClient(supabaseUrl, supabaseAnonKey, {
      global: { headers: { 'x-device-id': getDeviceId() } },
    })
  : null;
